import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SettingsIntegration } from '@app/models/company/settings/settings-integration.model';
import { NotifyService } from '@app/services';
import { ATSJobIntegration } from '@models/company/ats-job-integration.model';
import { JobIndeedIntegration } from '@models/company/job-indeed-integration.model';
import { JobPosting } from '@models/recruiting/job-posting.model';

@Component({
    selector: 'app-job-board-integrations',
    templateUrl: './job-board-integrations.template.html',
    styleUrls: ['./job-board-integrations.style.scss'],
})
export class JobBoardIntegrationsComponent implements OnInit {
    @Input() jobIntegration: ATSJobIntegration | null;
    @Input() jobIndeedIntegration: JobIndeedIntegration | null;
    @Input() integration: SettingsIntegration | null;
    @Input() jobPosting: JobPosting;
    @Input() isSyncing = false;
    @Input() isFailed = false;
    @Input() indeedPublicUrl: string | undefined; // TODO Indeed, new integration - deprecated
    @Output() integrationChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() invalidBillingState: EventEmitter<void> = new EventEmitter<void>();

    constructor(
        private router: Router,
        private notify: NotifyService
    ) {}

    async ngOnInit(): Promise<void> {
        this.isSyncing = this.jobIntegration?.isEnabled && !this.jobIndeedIntegration;
    }

    onOpenLink(): void {
        if (!this.indeedPublicUrl) {
            return;
        }

        window.open(this.indeedPublicUrl);
    }

    onConnectIntegration(): void {
        this.router.navigate(['/', 'settings', 'integrations-v2']);
    }
}
